export function paymentMode (ua) {
  if (/MicroMessenger/i.test(ua)) return 'JSAPI'
  if (/Android|iPhone|iPad|iPod|Mobile/i.test(ua)) return 'H5'
  return null
}
export function h5PaymentUrl (url, returnUrl) {
  const target = new URL(url)
  if (target.protocol !== 'https:' || target.hostname !== 'wx.tenpay.com') throw new Error('微信支付链接异常')
  target.searchParams.set('redirect_url', returnUrl)
  return target.toString()
}
export function invokeJsapi (params) {
  return new Promise((resolve, reject) => {
    let timer
    const ready = () => {
      document.removeEventListener('WeixinJSBridgeReady', ready)
      clearTimeout(timer)
      if (!window.WeixinJSBridge) { reject(new Error('请在微信中打开支付页面')); return }
      window.WeixinJSBridge.invoke('getBrandWCPayRequest', {
        appId: params.appId, timeStamp: params.timeStamp, nonceStr: params.nonceStr,
        package: params.package, signType: params.signType, paySign: params.paySign
      }, result => {
        if (result.err_msg === 'get_brand_wcpay_request:ok') resolve()
        else reject(new Error(result.err_msg === 'get_brand_wcpay_request:cancel' ? '已取消支付，订单仍待支付' : '微信支付未完成，请重试或检查支付配置'))
      })
    }
    if (window.WeixinJSBridge) ready()
    else {
      document.addEventListener('WeixinJSBridgeReady', ready)
      timer = setTimeout(() => { document.removeEventListener('WeixinJSBridgeReady', ready); reject(new Error('微信支付组件加载超时，请重新打开页面')) }, 10000)
    }
  })
}
